import { useEffect } from "react";

/**
 * Re-run `reload` on every impersonation Live-watch tick — the
 * ImpersonationBanner dispatches a window "em:live-tick" CustomEvent every
 * 5 s while the owner is watching a user read-only. Views with an existing
 * load() just call this once to become live-updating.
 */
export const useLiveTick = (reload) => {
  useEffect(() => {
    if (!reload) return undefined;
    const h = () => reload();
    window.addEventListener("em:live-tick", h);
    return () => window.removeEventListener("em:live-tick", h);
  }, [reload]);
};
